import { Swiper } from 'swiper';
import {Navigation} from "swiper/modules";
Swiper.use([Navigation]);

export default () => {
    const nodeSelectors = {
        container: '[js-events-slider="container"]',
        slider: '[js-events-slider="slider"]',
        prev: '[js-events-slider="prev"]',
        next: '[js-events-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                spaceBetween: 25,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 1
                    },
                    1100: {
                        slidesPerView: 2
                    },
                    1400: {
                        slidesPerView: 3
                    }
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}